import gql from "graphql-tag";

export const CUSTOMER_LIST_SEARCH = gql`
  query customerListSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: CustomerFilter
  ) {
    customers(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters
    ) {
      id
      unit {
        id
        name
        closedDate
      }
      deliveryLocations {
        id
        address
        city
        zip
        country {
          code
          name
        }
      }
      creditDays
      reference
      unofficialName
    }
  }
`;
